'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import dynamic from 'next/dynamic'

/**
 * Lazy client boundaries for the heavy forms. Every page renders through the [...slug] route, and
 * Turbopack groups eagerly-referenced client components into that route's shared chunk set — so a
 * direct import of any form ships react-hook-form, zod and the whole wizard to legal and blog
 * readers too. `next/dynamic` only defers on the client when the boundary itself is a client
 * component (in a server component the chunk is preloaded anyway), which is why this file exists.
 * The forms stay server-rendered (no `ssr: false`); only the hydration chunk is page-local.
 */
export const ContactForm = dynamic(() => import('./contact-form').then((m) => m.ContactForm))

export const LoginForm = dynamic(() => import('./login/login-form').then((m) => m.LoginForm))

export const RegisterForm = dynamic(() => import('./register/register-form').then((m) => m.RegisterForm))
